import React, {useState, useEffect, useRef} from 'react'

import classes from './ActivityLogoName.module.css'


const ActivityLogoName = ({mg, showDescr = false}) => {

  if (!mg) return null

  const name = mg.name
  const icon = mg.icon
  const descr = mg.description

  return (
    <div className={classes.ActivityLogoName}>

      <div className={classes.mgIcon}>
        <div className={classes.MinigameIcon}>
          {icon && <img src={icon} />}
        </div>
      </div>
      <div className={classes.mgName}>
        <span>{name}</span>
      </div>
      {(showDescr && descr) &&
      <h1 className={classes.description} dangerouslySetInnerHTML={{__html: descr}} />}
    </div>
  );
};

export default ActivityLogoName;
